import * as React from 'react';

function SvgTerminal(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 1.833H7.333A3.667 3.667 0 003.667 5.5v11a3.667 3.667 0 003.666 3.667H16.5a1.833 1.833 0 001.833-1.834V3.667A1.833 1.833 0 0016.5 1.833zM5.5 5.5a1.833 1.833 0 011.833-1.833H16.5v9.166H7.333c-.646.003-1.28.18-1.833.514V5.5zm1.833 12.833a1.833 1.833 0 110-3.666H16.5v3.666H7.333zm1.834-11h3.666a.916.916 0 100-1.833H9.167a.917.917 0 100 1.833z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgTerminal;
